import { motion } from 'framer-motion';

export function TrustStripMonday() {
  const partners = [
    { name: 'GAF', style: 'font-extrabold tracking-tight text-xl sm:text-2xl' },
    { name: 'OWENS CORNING', style: 'font-bold tracking-widest text-sm sm:text-base uppercase' },
    { name: 'EagleView', style: 'font-semibold tracking-tight text-lg sm:text-xl italic' },
    { name: 'Beacon Pro+', style: 'font-bold tracking-tight text-base sm:text-lg' },
    { name: 'ABC Supply', style: 'font-extrabold tracking-tight text-base sm:text-lg uppercase' },
    { name: 'CompanyCam', style: 'font-semibold tracking-normal text-base sm:text-lg' },
    { name: 'QuickBooks', style: 'font-bold tracking-tight text-base sm:text-lg' },
  ];

  const liveBenchmarks = [
    { value: '1.8 Rings', label: '24/7 Inbound Call Pickup' },
    { value: '90 Seconds', label: '3D Satellite Roof Takeoff' },
    { value: '38 Seconds', label: 'Speed-to-Lead SMS Reply' },
    { value: '$0 / Report', label: 'Unlimited Roof Measurements' },
  ];

  return (
    <section className="py-10 sm:py-12 bg-white border-b border-gray-100">
      <div className="max-w-[1360px] mx-auto px-5 sm:px-8">
        {/* Exact monday.com Slice 01 Centered Trust Caption + Monochrome Wordmark Strip */}
        <p className="text-center text-xs sm:text-[14px] font-normal text-[#323338] mb-7">
          Integrates with the tools and suppliers roofing contractors rely on every day
        </p>

        <div className="flex flex-wrap items-center justify-center gap-x-8 sm:gap-x-12 gap-y-5 opacity-80">
          {partners.map((partner, idx) => (
            <motion.span
              key={partner.name}
              initial={{ opacity: 0, y: 6 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.3, delay: idx * 0.04 }}
              className={`text-[#181B20] select-none ${partner.style}`}
            >
              {partner.name}
            </motion.span>
          ))}
        </div>

        {/* Compact Live Benchmark Pills */}
        <div className="mt-8 pt-6 border-t border-gray-100 flex flex-wrap items-center justify-center gap-4 sm:gap-8 text-xs text-[#676879]">
          {liveBenchmarks.map((b) => (
            <div key={b.label} className="inline-flex items-center gap-2">
              <span className="font-semibold text-[#181B20]">{b.value}</span>
              <span>· {b.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
